import { render, staticRenderFns } from "./fotograflar.vue?vue&type=template&id=3ed3f7ff&"
import script from "./fotograflar.vue?vue&type=script&lang=js&"
export * from "./fotograflar.vue?vue&type=script&lang=js&"
import style0 from "./fotograflar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports